import { graphql, useStaticQuery } from 'gatsby';
import type { IGatsbyImageData as GatsbyImageData } from 'gatsby-plugin-image';

type Data = {
  file: { sharp: { gatsbyImageData: GatsbyImageData } };
};

export const useAvatarImage = () => {
  const data = useStaticQuery<Data>(graphql`
    query {
      file(relativePath: { eq: "avatar.png" }) {
        sharp: childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);

  return data.file.sharp.gatsbyImageData;
};
